import { render, staticRenderFns } from "./InsurancePolicyForm.vue?vue&type=template&id=3c5d4adc"
import script from "./InsurancePolicyForm.vue?vue&type=script&lang=js"
export * from "./InsurancePolicyForm.vue?vue&type=script&lang=js"
import style0 from "./InsurancePolicyForm.vue?vue&type=style&index=0&id=3c5d4adc&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports